import React, {useEffect} from 'react'
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

function ExampleVideos() {
    useEffect(() => {
        Fancybox.bind('[data-fancybox="single"]', {
            groupAttr: false,
        });
    
        return () => {
            Fancybox.destroy(); // Cleanup Fancybox when component unmounts
        };
    }, []);
  return (
    <section class="fifty-example-videos" id="fifty-example-videos">
        <div class="row ">
            <div class="container">
                <div class="what-are-snap-video-wrap wow zoomIn">
                    <div class="top-content">
                        <div class="title">
                            <h2>Sample <span class="red">Videos</span></h2>
                        </div>
                    </div>
                
                    <div class="popup-content">
                        <div class="popup-wrap">
                            <div class="popup-box wow fadeInLeft">
                                <div class="fifty-popup-image">
                                    <a data-fancybox="single" href="https://vimeo.com/1085788599" class="popup popup-btn"></a>
                                    <img src="/images/firstFifty-images/pop-up-image.jpg" />
                                </div>								
                            </div>
                            <div class="popup-box wow zoomIn">
                                <div class="fifty-popup-image">
                                    <a data-fancybox="single" href="https://vimeo.com/1085754386" class="popup popup-btn"></a>
                                    <img src="/images/firstFifty-images/pop-up-image1.jpg" />
                                </div>									
                            </div>
                            <div class="popup-box wow fadeInRight">
                                <div class="fifty-popup-image">
                                    <a data-fancybox="single" href="https://vimeo.com/1080643342" class="popup popup-btn"></a>
                                    <img src="/images/firstFifty-images/pop-up-image2.jpg" />
                                </div>						
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default ExampleVideos